import Vue from 'vue'
import Router from 'vue-router'
import Menu from '@/components/AppMenu/Menu/Menu'
import Cliente from '@/components/AppLogin/Cliente/Cliente'
import Login from '@/components/AppLogin/Login/Login'

const Dashboard   	= () => import('@/components/AppMenu/Dashboard/Dashboard.vue');
const Empleados  	= () => import('@/components/AppMenu/Empleados/Empleados.vue');
const Departamentos = () => import('@/components/AppMenu/Departamentos/Departamentos.vue');
const Usuarios  	= () => import('@/components/AppMenu/Usuarios/Usuarios.vue');
const Perfiles  		= () => import('@/components/AppMenu/Perfiles/Perfiles.vue');
const Aplicar_Prueba  	= () => import('@/components/AppMenu/Aplicar_Prueba/Aplicar_Prueba.vue');
const Tests  			= () => import('@/components/AppMenu/Tests/Tests.vue');
const Tests_Empleados  	= () => import('@/components/AppMenu/Tests/Empleados/Empleados.vue');
const Tests_Empleados_Resultados  = () => import('@/components/AppMenu/Tests/Empleados/Resultados/Resultados.vue');

Vue.use(Router)

export default new Router({
	mode:'history',
  	routes: [
	  	{ path: '/', 						name: 'Cliente',  component: Cliente},
	  	{ path: '/login', 					name: 'Login', 	  component: Login },
	  	{ path: '/cliente/:clave_cliente', 	name: 'Cliente2', component: Cliente},
	    { path: '/menu', 					name: 'Menu', component: Menu, children:[
	    	{ path: 'dashboard', 	name: 'Dashboard', 		component: Dashboard },
	    	{ path: 'empleados',	name: 'Empleados',component: Empleados },
	    	{ path: 'departamentos',name: 'Departamentos',component: Departamentos },
	    	{ path: 'usuarios', 	name: 'Usuarios', component: Usuarios },
	    	{ path: 'perfiles',   	name: 'Perfiles', 			component: Perfiles },
	    	{ path: 'aplicar',   	name: 'Aplicar_Prueba', 	component: Aplicar_Prueba },
	    	{ path: 'tests',   	 	name: 'Tests', 			component: Tests },
	    	{ path: 'tests/empleados',   		   name: 'Tests_Empleados', 			component: Tests_Empleados },
	    	{ path: 'tests/empleados/resultados',  name: 'Tests_Empleados_Resultados', 			component: Tests_Empleados_Resultados },
	    ]}
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js